export default __webpack_public_path__ + "static/media/DinnersClub.f7635d71.svg";